import React from "react";
import stars from "../../../new_images/Landing/Icons/Icon_5_stars.png";
import "./CustomerReview.css";

class CustomerReview extends React.Component {
  render() {
    return (
      <div className="col customerReview">
        <div className="header">
          <img
            className="round_image"
            src={this.props.avatar}
            alt="avatar"
            height="10px"
          />
          <img className="stars" src={stars} height="20px" alt="stars" />
        </div>
        <div className="body">
          <p className="name">{this.props.name}</p>
          <p className="review">{this.props.review}</p>
        </div>
      </div>
    );
  }
}

export default CustomerReview;
